    //console.log(jQuery("#download_all").length);
    if(jQuery("#download_all").length){
        jQuery("#download_all").on('click',function(e){
            e.preventDefault();
            var files_list = jQuery("input[name=filestodownload]").val();
            var dest = jQuery("input[name=dest]").val();
            console.log(files_list);
            console.log(dest);
            var win = window.open(dest+'/includes/download_assets_zip.php/?f='+files_list, '_blank');
            if (win) {
              //Browser has allowed it to be opened
              win.focus();
            } else {
                //Browser has blocked it
                alert('Please allow popups for this website');
            }
            /*
            $.ajax({
              type: "POST",
              async: false,
              url: ",
              data: {
                file_list: files_list,
              },
              success: function(data){
                console.log(data);
                var a = document.createElement("a");
                a.href = data;
                a.download = "assets.zip";
                document.body.appendChild(a);
                a.click();
                a.remove();
              },
            });
            */
            
        })
    }
